import React from 'react';
import HeroSlider from '../components/HeroSlider';
import AboutOverview from '../components/AboutOverview';
import CoursesGrid from '../components/CoursesGrid';
import WhyChooseUs from '../components/WhyChooseUs';
import NextEventOverview from '../components/NextEventOverview';
import CareerOpportunities from '../components/CareerOpportunities';
import PlacementCell from '../components/PlacementCell';
import FooterCTA from '../components/FooterCTA';
import HomeFAQ from '../components/HomeFAQ';
import FranchiseOffers from '../components/FranchiseOffers';
import '../css/Home.css';

const Home = () => {
  return (
    <div className="gfi-homepage-master">
      {/* 1. HERO SLIDER SECTION (With Floating Cards Inside) */}
      <section className="gfi-home-hero-block">
        <HeroSlider />
      </section>

      {/* 2. FUTURE CONTENT AREA BLOCK */}
      <section className="gfi-home-body-block">
        <div className="gfi-home-welcome-container">
          <span className="gfi-welcome-badge">WELCOME TO THE ACADEMY</span>
          <h2 className="gfi-home-main-title">
            Empowering Minds, Ensuring Safety Everywhere
          </h2>
          <p className="gfi-home-lead-text">
           Welcome to Greenfield Industrial Fire and Safety Academy (GIFSA) an ISO Certified Institute – the Best Fire Safety College in India Welcome to Greenfield Industrial Fire and Safety Academy, a division of an authorized national training provider for Fire and Safety Courses at all over india. We are in association with MSME- Kanpur (Ministry of Micro, Small & Medium Enterprises, Govt.of India .
          </p>
          <p className="gfi-home-lead-text">
          Our Institute is Having remarkable facilities in Order to assure the best ever training to a student opting for career in the field of Fire and Safety Engineering. The institute was incorporated with a vision of using rich experience, expertise, infrastructure in order to produce the best talents for meeting the demands of clients both in India and abroad.
          </p>
          
          {/* Temporary Placeholder for Next Blocks */}
          <div className="gfi-placeholder-grid">
            <div className="gfi-p-box">🛡️ Fire & Safety Programs</div>
            <div className="gfi-p-box">🏅 International Certifications</div>
            <div className="gfi-p-box">👷 Industrial HSE Training</div>
            
          </div>
        </div>
      </section>
      
      {/* 3. NEXT SECTIONS COMING HERE... */}
     <AboutOverview/>
       <CoursesGrid/>
        <WhyChooseUs/>
         <NextEventOverview/>
          <CareerOpportunities/>
           <PlacementCell/>
            <FooterCTA/>
              <FranchiseOffers/>
                 <HomeFAQ/>
      {/* <CoursesGrid /> */}
    </div>
  );
};

export default Home;